
var game_size = get_game_size();
// var game = new Phaser.Game( game_size.width, game_size.height, Phaser.CANVAS, 'game-canvas', null, false, false );

// console.log( Phaser.CANVAS );

var game = new Phaser.Game(
	{
		width: game_size.width,
		height: game_size.height,
		renderer: Phaser.CANVAS,
		parent: 'game-canvas',
		antialias: false,
		roundPixels: true,
		crisp: true,
	}
);

// Define states
game.state.add( 'boot', Game.States.Boot );
game.state.add( 'load', Game.States.Load );
game.state.add( 'load-world', Game.States.LoadWorld );
game.state.add( 'menu', Game.States.Menu );
game.state.add( 'world', Game.States.World );

// Start the "boot" state
game.state.start( 'boot' );
